module.exports = "/_next/static/images/savedForLaterLight-a90b26c56c35c7a23ee3b377144c11b0.svg";